<template>
  <div class="columnists">
    <span id="c-add-up">
      <ColumnistAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
      />
    </span>
    <va-card :title="$t('columnists.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#c-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="columnists"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="active" slot-scope="props">
          <va-toggle
            small
            :value="props.rowData.active"
            :label="props.rowData.active ? 'Sim' : 'Não'"
            @input="toggleActive(props.rowData)"
          />
        </template>
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('columnists.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('columnists.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ColumnistAddUpdate from './ColumnistAddUpdate'
const perPage = 10
export default {
  name: 'columnists',
  components: {
    ColumnistAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.columnists.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.logo,
            path: 'profile-image',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_collumn_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    toggleActive (row) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!, $active: Boolean!) {
              update_collumn_by_pk(pk_columns: {id: $id}, _set: {active: $active}) {
                id
                active
              }
            }
          `,
          variables: {
            id: row.id,
            active: !row.active,
          },
        })
        .then(_ => {
          this.$apollo.queries.columnists.refetch()
          this.showToast(
            this.$t('toasts.successUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.$apollo.queries.columnists.refetch()
          this.showToast(
            this.$t('toasts.errorUpdate'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      columnists: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    columnists: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        columnists: collumn(limit: $perPage, offset: $page, order_by: {id: asc}) {
          id
          image
          slug
          bio
          user_id
          active
          user {
            id
            name
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: collumn_aggregate {
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'user',
        title: this.$t('columnists.headings.name'),
        width: '60%',
        callback (value) {
          return value ? value.name : ''
        },
      }, {
        name: '__slot:active',
        title: this.$t('columnists.headings.active'),
        width: '120px',
        dataClass: 'text-center',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('columnists')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.columnists.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
